import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl, ValidationErrors, FormGroup, FormControl } from '@angular/forms';
import { BaseValidator } from 'src/app/validators/base-validator'

@Injectable({
  providedIn: 'root'
})

export class UrlValidator extends BaseValidator {

  constructor() {
    super();
  }

  validateUrl(): ValidatorFn {
    return (control: FormControl): { [key: string]: boolean } | null => {

      if (control) {

        let controlName = this.getControlName(control);

        if(controlName){

          let url = control.parent && control.parent.get(controlName) ? control.parent.get(controlName).value : '';

          if (url && url.length >= 450) {
            return { invalidUrlLength : true };
          }
        }
      }

    };
  }
}
